<template>
    <div>
        <div class="qr-code">
            <qrcodes id="ysyqrocde" :url="url" :iconurl="iconurl" :wid="wid" :hei="hei" :imgwid="imgwid" :imghei="imghei" />
            <div class="mask-code" @click="saveQrcode">
                <span>保存二维码</span>
            </div>
        </div>
    </div>
</template>
    
<script>
import qrcodes from 'vue_qrcodes'
import html2canvas from 'html2canvas'

export default {
    name: 'QRCodeLogo',
    props: {
        wid: {
            type: Number,
            default: 200
        },
        hei: {
            type: Number,
            default: 200
        },
        imgwid: {
            type: Number,
            default: 60
        },
        imghei: {
            type: Number,
            default: 60
        },
        url: {
            type: String,
            required: true
        },
        iconurl: {
            type: String,
            required: true
        }
    },
    components: {
        qrcodes
    },
    mounted() {
    },
    methods: {
        saveQrcode() {
            html2canvas(document.getElementById('ysyqrocde'), {
                scale: 2, //缩放比例,默认为1
                allowTaint: false, //是否允许跨域图像污染画布
                useCORS: true, //是否尝试使用CORS从服务器加载图像
                width: this.wid, //画布的宽度
                height: this.hei, //画布的高度
                backgroundColor: '#fff', //画布的背景色，默认为透明
            }).then((canvas) => {
                //将canvas转为base64格式，生成图片链接
                let imgUrl = canvas.toDataURL('image/png');
                setTimeout(() => {
                    this.downloadIamge(imgUrl);
                }, 300)

            })
        },
        downloadIamge(url) { // 下载图片
            // let base64Img = document.getElementById('ysyqrocde').toDataURL('image/jpg');
            let base64Img = url
            //创建下载标签，然后设置链接和图片名称
            let a = document.createElement('a')
            a.href = base64Img
            a.download = '二维码' + Date.now()
            a.click()
            a.remove()
        },
    }
};
</script>

<style scoped>
.qr-code {
    display: flex;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    position: relative;
    margin: auto;
}

.qr-code:hover>div {
    z-index: 0;
}

.mask-code {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.7);
}

.mask-code span {
    color: white;
    font-size: medium;
}
</style>



// WEBPACK FOOTER //
// src/common/QRcodeLogo.vue